import React from 'react';
import cactusEmptyStateIllustration from '@/assets/cactus-empty-state.svg';
import { BodyMedium, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import styles from './EmptyState.styles';

export const EmptyState: React.FC = () => (
  <div className={styles.container}>
    <img
      src={cactusEmptyStateIllustration}
      width="64"
      height="64"
      alt=""
      data-testid="empty-illustration"
    />
    <div className={styles.content}>
      <TitleSmallEmphasized as="h3" color={colors.slate}>
        No organizations yet
      </TitleSmallEmphasized>
      <BodyMedium color={colors.slate}>
        When you follow organizations, they&apos;ll appear here.
      </BodyMedium>
    </div>
  </div>
);
